import { CREATE_PRODUCT_DISPATCH_DETAIL_FAILURE, CREATE_PRODUCT_DISPATCH_DETAIL_REQUEST, CREATE_PRODUCT_DISPATCH_DETAIL_SUCCESS, CREATE_PRODUCT_DISPATCH_FAILURE, CREATE_PRODUCT_DISPATCH_REQUEST, CREATE_PRODUCT_DISPATCH_SUCCESS, CREATE_USERFORM_PRODUCT_DISPATCH_TABLE_LIST_DATA, CREATE_USER_FORM_PRODUCT_DISPATCH, DELETE_PRODUCT_DISPATCH_DETAIL_FAILURE, DELETE_PRODUCT_DISPATCH_DETAIL_REQUEST, DELETE_PRODUCT_DISPATCH_HEADER_FAILURE, DELETE_PRODUCT_DISPATCH_HEADER_REQUEST, FETCH_PRODUCT_DISPATCH_DETAIL_DATA_FAILURE, FETCH_PRODUCT_DISPATCH_DETAIL_DATA_REQUEST, FETCH_PRODUCT_DISPATCH_DETAIL_DATA_SUCCESS, FETCH_PRODUCT_DISPATCH_SALES_ORDER_FAILURE, FETCH_PRODUCT_DISPATCH_SALES_ORDER_REQUEST, FETCH_PRODUCT_DISPATCH_SALES_ORDER_SUCCESS, FETCH_PRODUCT_STOCK_DATA_FAILURE, FETCH_PRODUCT_STOCK_DATA_REQUEST, FETCH_PRODUCT_STOCK_DATA_SUCCESS, FETCH_WAREHOUSE_CUSTOMER_PO_PENDING_LIST_FAILURE, FETCH_WAREHOUSE_CUSTOMER_PO_PENDING_LIST_REQUEST, FETCH_WAREHOUSE_CUSTOMER_PO_PENDING_LIST_SUCCESS, FETCH_WAREHOUSE_DISPATCH_DETAIL_TABLE_FAILURE, FETCH_WAREHOUSE_DISPATCH_DETAIL_TABLE_REQUEST, FETCH_WAREHOUSE_DISPATCH_DETAIL_TABLE_SUCCESS, FETCH_WAREHOUSE_DISPATCH_SUPPLIER_LIST_FAILURE, FETCH_WAREHOUSE_DISPATCH_SUPPLIER_LIST_REQUEST, FETCH_WAREHOUSE_DISPATCH_SUPPLIER_LIST_SUCCESS, FETCH_WAREHOUSE_SALES_ORDER_LIST_FAILURE, FETCH_WAREHOUSE_SALES_ORDER_LIST_REQUEST, FETCH_WAREHOUSE_SALES_ORDER_LIST_SUCCESS, NAVIGATE_PRODUCT_DISPATCH_DETAIL, NAVIGATE_PRODUCT_DISPATCH_HEADER, NAVIGATE_PRODUCT_STOCK_HEADER, PRODUCT_DISAPTCH_USERFORM_RESET, SET_UNIT_NAME_PRODUCT_DISPATCH } from "./productDispatch.actionsType";



export const PRODUCT_DISPATCH = 'productDispatch';

let initialState = {
    loading: false,
    productDispatchData: [],
    isProductDispatch: false,
    userform: {
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1,
        fldFKDeliveryLocation: '',
        fldEstimatDeliveryDate: new Date(),
        fldDeliveredDate: new Date(),
        fldAgainstCPO: false,
        fldFKTransporterID: '',
        fldFKCustomerID: '',
    },
    activeKey: 1,
    detailsId: '',
    productDispatchSalesOrder: [],
    productDispatchSelectedValue: {},
    productDispatchDetailGridData: [],
    productDispatchPendingList: [],
    productDispatchDetailData: [],
};

export let productDispatchReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PRODUCT_STOCK_DATA_REQUEST:
        case CREATE_PRODUCT_DISPATCH_REQUEST:
        case FETCH_PRODUCT_DISPATCH_SALES_ORDER_REQUEST:
        case CREATE_PRODUCT_DISPATCH_DETAIL_REQUEST:
        case DELETE_PRODUCT_DISPATCH_HEADER_REQUEST:
        case FETCH_PRODUCT_DISPATCH_DETAIL_DATA_REQUEST:
        case DELETE_PRODUCT_DISPATCH_DETAIL_REQUEST:
        case FETCH_WAREHOUSE_SALES_ORDER_LIST_REQUEST:
        case FETCH_WAREHOUSE_CUSTOMER_PO_PENDING_LIST_REQUEST:
        case FETCH_WAREHOUSE_DISPATCH_DETAIL_TABLE_REQUEST:
        case FETCH_WAREHOUSE_DISPATCH_SUPPLIER_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case CREATE_USER_FORM_PRODUCT_DISPATCH:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                },
            };
        case FETCH_PRODUCT_STOCK_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                productDispatchData: updatePayload
            };
        case CREATE_PRODUCT_DISPATCH_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId,
                    fldFKSaleOrder: state.userform.fldFKSaleOrder,
                    fldEstimatDeliveryDate: state.userform.fldEstimatDeliveryDate,
                    fldDeliveredDate: state.userform.fldDeliveredDate,
                    fldAgainstCPO: state.userform.fldAgainstCPO
                },
                detailsId: updatePayload,
            };
        case FETCH_PRODUCT_DISPATCH_SALES_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                productDispatchSalesOrder: updatePayload
            };
        case CREATE_USERFORM_PRODUCT_DISPATCH_TABLE_LIST_DATA:
            return {
                ...state,
                productDispatchSalesOrder: payload
            };
        case CREATE_PRODUCT_DISPATCH_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                productDetailId: updatePayload
            };
        case FETCH_PRODUCT_DISPATCH_DETAIL_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                productDispatchDetailGridData: updatePayload
            };
        case FETCH_WAREHOUSE_SALES_ORDER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                WareHouseSalesOrderList: updatePayload
            };
        case FETCH_WAREHOUSE_CUSTOMER_PO_PENDING_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                productDispatchPendingList: updatePayload
            };
        case FETCH_WAREHOUSE_DISPATCH_DETAIL_TABLE_SUCCESS:
            return {
                ...state,
                loading: false,
                productDispatchDetailData: updatePayload
            };
        case FETCH_WAREHOUSE_DISPATCH_SUPPLIER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                wareHouseSupplierList: updatePayload
            };
        case FETCH_PRODUCT_STOCK_DATA_FAILURE:
        case CREATE_PRODUCT_DISPATCH_FAILURE:
        case FETCH_PRODUCT_DISPATCH_SALES_ORDER_FAILURE:
        case CREATE_PRODUCT_DISPATCH_DETAIL_FAILURE:
        case DELETE_PRODUCT_DISPATCH_HEADER_FAILURE:
        case FETCH_PRODUCT_DISPATCH_DETAIL_DATA_FAILURE:
        case DELETE_PRODUCT_DISPATCH_DETAIL_FAILURE:
        case FETCH_WAREHOUSE_SALES_ORDER_LIST_FAILURE:
        case FETCH_WAREHOUSE_CUSTOMER_PO_PENDING_LIST_FAILURE:
        case FETCH_WAREHOUSE_DISPATCH_DETAIL_TABLE_FAILURE:
        case FETCH_WAREHOUSE_DISPATCH_SUPPLIER_LIST_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_PRODUCT_DISPATCH_HEADER:
            return {
                ...state,
                loading: false,
                isProductDispatch: false
            };
        case SET_UNIT_NAME_PRODUCT_DISPATCH:
            return {
                ...state,
                unitId: payload
            };
        case NAVIGATE_PRODUCT_DISPATCH_DETAIL:
            return {
                ...state,
                isProductDispatch: true,
                loading: false,
                productDispatchSelectedValue: updatePayload.productDispatchSelectedValue
            };
        case PRODUCT_DISAPTCH_USERFORM_RESET:
            return {
                ...state,
                productDispatchSalesOrder: [],
                userform: {
                    fldFKSaleOrder: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId,
                    fldEstimatDeliveryDate: state.userform.fldEstimatDeliveryDate,
                    fldDeliveredDate: state.userform.fldDeliveredDate,
                    fldAgainstCPO: false,
                    fldFKTransporterID: '',
                    fldFKCustomerID: '',
                },
                productDispatchDetailData: [],
                detailsId: ''
            }
        default:
            return state;
    }
};